import styled from 'styled-components'

export const Wrapper = styled.div`
  overflow: hidden;
  height: 0px;

  > div {
    width: 1100px;
    height: 852px;
  }
`
